export default [
    {
        path: '/coupon/list',
        name: 'coupon_list',
        component: () => import('@src/coupon/coupon-list'),
        meta: {
            title: 'Alle Coupons',
            role: 'ROLE_LIST_COUPON',
        },
    },
    {
        path: '/coupon/edit/:id',
        name: 'coupon_edit',
        component: () => import('@src/coupon/coupon'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Coupon bearbeiten',
            role: 'ROLE_EDIT_COUPON',
        },
    },
    {
        path: '/coupon/create/:idCopyFrom?',
        name: 'coupon_create',
        component: () => import('@src/coupon/coupon.vue'),
        props(route) {
            return { idCopyFrom: route.params.idCopyFrom ? Number.parseInt(route.params.idCopyFrom) : null };
        },
        meta: {
            title: 'Coupon anlegen',
            role: 'ROLE_EDIT_COUPON',
        },
    },
    {
        path: '/coupon/show-newsletter/:id',
        name: 'coupon_show_newsletter',
        component: () => import('@src/coupon/coupon-show-newsletter'),
        props(route) {
            const props = { ...route.params };
            props.id = Number(props.id);

            return props;
        },
        meta: {
            title: 'Newsletter Coupon generieren',
            role: 'ROLE_CREATE_NEWSLETTER_COUPON',
        },
    },
];
